import React, { useEffect } from 'react'
import { DataPicCorporate, InfoPerusahaanCorporate } from '../../components'
import useFetchUserByToken from '../../hooks/useFetchUserByToken'
import { useLocation } from 'react-router-dom';

const ProfilCorporatePage = () => {

    const location = useLocation();

    useEffect(() => {
        window.dataLayer.push({
            event: 'pageview',
            page: {
            url: window.location.pathname + window.location.search,
            title: document.title
            }
        });
    }, [location]);
    
    return (
        <div>
            <h3>Profil Perusahaan</h3>
            <nav aria-label="breadcrumb" >
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <span href="#" style={{
                            color: '#B5B5C3'
                        }}>Beranda</span>
                    </li>
                    <li className="breadcrumb-item active" ariaCurrent="page" style={{
                        color: '#3F4254'
                    }}>Data Profil</li>
                </ol>
            </nav>
            <div className='row mt-4 mb-4'>
                <div className='col-lg-12'>
                    <DataPicCorporate />
                </div>
            </div>
            <div className='row'>
                <div className='col-lg-12'>
                    <InfoPerusahaanCorporate />
                </div>
            </div>
        </div>
    )
}

export default ProfilCorporatePage
